document.addEventListener('DOMContentLoaded', () => {
  const ageGate = document.querySelector('[data-age-gate]');
  const ageGateKey = 'hipgaga-age-confirmed';
  const legacyAgeGateKey = 'qr-age-confirmed';
  const isAgeConfirmed = localStorage.getItem(ageGateKey) === 'true' || localStorage.getItem(legacyAgeGateKey) === 'true';

  if (ageGate && !isAgeConfirmed) {
    ageGate.hidden = false;
    document.body.classList.add('is-locked');
    ageGate.querySelector('[data-age-confirm]')?.focus();
  }

  ageGate?.querySelector('[data-age-confirm]')?.addEventListener('click', () => {
    localStorage.setItem(ageGateKey, 'true');
    localStorage.setItem(legacyAgeGateKey, 'true');
    ageGate.hidden = true;
    document.body.classList.remove('is-locked');
  });

  ageGate?.querySelector('[data-age-deny]')?.addEventListener('click', (event) => {
    localStorage.removeItem(ageGateKey);
    localStorage.removeItem(legacyAgeGateKey);
    document.body.classList.add('is-locked');
    window.location.href = event.currentTarget.dataset.ageExitUrl || 'https://www.google.com/';
  });

  const menuButton = document.querySelector('[data-mobile-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  menuButton?.addEventListener('click', () => {
    const open = mobileNav.classList.toggle('is-open');
    menuButton.setAttribute('aria-expanded', String(open));
  });

  const mobileMenuOpen = document.querySelector('[data-mobile-menu-open]');
  const mobileMenuClose = document.querySelector('[data-mobile-menu-close]');
  const mobileMenuDrawer = document.querySelector('[data-mobile-menu-drawer]');
  const mobileMenuOverlay = document.querySelector('[data-mobile-menu-overlay]');

  const closeMobileMenu = () => {
    if (!mobileMenuDrawer || !mobileMenuOpen) return;
    mobileMenuDrawer.classList.remove('open');
    mobileMenuOverlay?.classList.remove('show');
    document.body.classList.remove('is-mobile-menu-open');
    mobileMenuDrawer.setAttribute('aria-hidden', 'true');
    mobileMenuOpen.setAttribute('aria-expanded', 'false');
  };

  const openMobileMenu = () => {
    if (!mobileMenuDrawer || !mobileMenuOpen) return;
    mobileMenuDrawer.classList.add('open');
    mobileMenuOverlay?.classList.add('show');
    document.body.classList.add('is-mobile-menu-open');
    mobileMenuDrawer.setAttribute('aria-hidden', 'false');
    mobileMenuOpen.setAttribute('aria-expanded', 'true');
    mobileMenuClose?.focus();
  };

  mobileMenuOpen?.addEventListener('click', openMobileMenu);
  mobileMenuClose?.addEventListener('click', closeMobileMenu);
  mobileMenuOverlay?.addEventListener('click', closeMobileMenu);

  mobileMenuDrawer?.querySelectorAll('[data-mobile-submenu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const submenu = document.getElementById(button.getAttribute('aria-controls'));
      const open = !submenu?.classList.contains('open');
      submenu?.classList.toggle('open', open);
      button.setAttribute('aria-expanded', String(open));
      const indicator = button.querySelector('span');
      if (indicator) indicator.textContent = open ? '-' : '+';
    });
  });

  mobileMenuDrawer?.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', closeMobileMenu);
  });

  const mobilePurchaseMedia = window.matchMedia('(max-width: 749px)');
  const cartPagePattern = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i;

  const isThemeOverlay = (element) => element.closest([
    '[data-age-gate]',
    '[data-cart-drawer]',
    '[data-sticky-atc]',
    '[data-header-search]',
    '[data-mobile-menu-drawer]',
    '[data-hipgaga-drawer]',
  ].join(','));

  const isElementVisible = (element) => {
    if (!element || element.hidden) return false;
    const rect = element.getBoundingClientRect();
    if (rect.width < 1 || rect.height < 1) return false;
    const computed = window.getComputedStyle(element);
    return computed.display !== 'none' && computed.visibility !== 'hidden' && Number(computed.opacity || 1) > 0;
  };

  const rectsOverlap = (first, second) => (
    first.left < second.right &&
    first.right > second.left &&
    first.top < second.bottom &&
    first.bottom > second.top
  );

  const smartPushElements = new Set();

  const isSmartPushElement = (element) => {
    if (!element || element === document.body || element === document.documentElement) return false;
    if (isThemeOverlay(element)) return;

    const attributes = [
      element.tagName,
      element.id,
      element.className,
      element.getAttribute?.('src'),
      element.getAttribute?.('href'),
      element.getAttribute?.('data-src'),
    ].filter(Boolean).join(' ').toLowerCase();
    const text = (element.textContent || '').slice(0, 500).toLowerCase();
    const computed = window.getComputedStyle(element);
    const zIndex = Number.parseInt(computed.zIndex, 10);
    const overlayLike = element.tagName === 'IFRAME' || computed.position === 'fixed' || computed.position === 'sticky' || zIndex >= 1000;
    const appMatched = attributes.includes('kmalgo') || attributes.includes('smartpush') || attributes.includes('smart-push');
    const popupMatched = overlayLike && (
      text.includes('7% off') ||
      text.includes('get my 7') ||
      text.includes('claim 7') ||
      text.includes('welcome to hipgaga')
    );

    return appMatched || popupMatched;
  };

  const getSmartPushElements = () => Array.from(smartPushElements).filter((node) => node.isConnected);

  const scanSmartPushElements = (root = document) => {
    const nodes = [];
    if (root.nodeType === Node.ELEMENT_NODE) nodes.push(root);
    root.querySelectorAll?.('smart-push-popup, iframe, [id], [class]').forEach((node) => nodes.push(node));
    nodes.forEach((node) => {
      if (isSmartPushElement(node)) smartPushElements.add(node);
    });
    return getSmartPushElements();
  };

  const visibleSmartPushOverlaps = (selectors) => {
    const popups = getSmartPushElements().filter(isElementVisible);
    if (!popups.length) return false;

    const targets = selectors
      .flatMap((selector) => Array.from(document.querySelectorAll(selector)))
      .filter(isElementVisible);
    if (!targets.length) return false;

    return popups.some((popup) => targets.some((target) => (
      rectsOverlap(popup.getBoundingClientRect(), target.getBoundingClientRect())
    )));
  };

  const isSmartPushLauncherLike = (element) => {
    if (!isElementVisible(element)) return false;

    const rect = element.getBoundingClientRect();
    const computed = window.getComputedStyle(element);
    const compact = rect.width <= Math.min(220, window.innerWidth - 24) && rect.height <= 220;
    const edgeAligned = rect.right >= window.innerWidth - 260 || rect.left <= 48;

    return compact && (computed.position === 'fixed' || computed.position === 'sticky' || element.tagName === 'IFRAME') && edgeAligned;
  };

  const suppressMobilePurchasePopups = () => {
    const candidates = getSmartPushElements();
    document.documentElement.classList.remove('hipgaga-mobile-smartpush-hidden');
    candidates.forEach((element) => {
      const hiddenByTheme = element.dataset.hipgagaSmartpushHidden === 'true';
      element.classList.remove('hipgaga-smartpush-hidden');
      element.classList.remove('hipgaga-smartpush-avoid-mobile-cta');
      if (hiddenByTheme && element.getAttribute('aria-hidden') === 'true') element.removeAttribute('aria-hidden');
      if (hiddenByTheme) delete element.dataset.hipgagaSmartpushHidden;
    });

    if (!mobilePurchaseMedia.matches) return;

    const overlayOpen = document.body.classList.contains('is-cart-drawer-open') ||
      document.body.classList.contains('is-hipgaga-filter-open') ||
      document.body.classList.contains('is-mobile-menu-open') ||
      document.body.classList.contains('is-locked') ||
      Boolean(document.querySelector('[data-header-search].is-open'));
    const smartPushNearCartCheckout = cartPagePattern.test(window.location.pathname) &&
      visibleSmartPushOverlaps(['button[name="checkout"]']);
    const shouldHide = overlayOpen;
    const shouldAvoidCta = !shouldHide && (
      document.body.classList.contains('has-mobile-sticky-atc') ||
      smartPushNearCartCheckout
    );

    document.documentElement.classList.toggle('hipgaga-mobile-smartpush-hidden', shouldHide);
    candidates.forEach((element) => {
      element.classList.toggle('hipgaga-smartpush-hidden', shouldHide);
      element.classList.toggle('hipgaga-smartpush-avoid-mobile-cta', shouldAvoidCta && isSmartPushLauncherLike(element));
      if (shouldHide) {
        element.dataset.hipgagaSmartpushHidden = 'true';
        element.setAttribute('aria-hidden', 'true');
      } else if (element.dataset.hipgagaSmartpushHidden === 'true' && element.getAttribute('aria-hidden') === 'true') {
        element.removeAttribute('aria-hidden');
        delete element.dataset.hipgagaSmartpushHidden;
      }
    });
  };

  mobilePurchaseMedia.addEventListener?.('change', suppressMobilePurchasePopups);
  window.addEventListener('scroll', suppressMobilePurchasePopups, { passive: true });
  window.addEventListener('resize', suppressMobilePurchasePopups);
  document.addEventListener('click', () => window.setTimeout(suppressMobilePurchasePopups, 0));
  scanSmartPushElements();
  suppressMobilePurchasePopups();

  if ('MutationObserver' in window) {
    const popupObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          scanSmartPushElements(node);
        });
      });
      suppressMobilePurchasePopups();
    });
    popupObserver.observe(document.body, { childList: true, subtree: true });
  }

  document.querySelectorAll('[data-footer-menu]').forEach((menu) => {
    const toggle = menu.querySelector('[data-footer-menu-toggle]');
    if (!toggle) return;

    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMobileMenu();
  });

  document.querySelectorAll('[data-header-notification]').forEach((notification) => {
    const toggle = notification.querySelector('[data-header-notification-toggle]');
    if (!toggle) return;

    const closeNotification = () => {
      notification.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    };

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const open = !notification.classList.contains('is-open');
      document.querySelectorAll('[data-header-notification].is-open').forEach((item) => {
        if (item !== notification) {
          item.classList.remove('is-open');
          item.querySelector('[data-header-notification-toggle]')?.setAttribute('aria-expanded', 'false');
        }
      });
      notification.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    });

    notification.addEventListener('click', (event) => event.stopPropagation());
    document.addEventListener('click', closeNotification);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeNotification();
    });
  });

  document.querySelectorAll('[data-header-search]').forEach((search) => {
    const toggle = search.querySelector('[data-header-search-toggle]');
    const form = search.querySelector('[data-header-search-form]');
    const input = search.querySelector('[data-header-search-input]');
    const results = search.querySelector('[data-header-search-results]');
    const launcher = search.querySelector('[data-header-search-launch-input]');
    const launchForm = search.querySelector('[data-header-search-launch-form]');
    const panel = search.querySelector('[data-header-search-panel]');
    const discovery = search.querySelector('[data-header-search-discovery]');
    const matches = search.querySelector('[data-header-search-matches]');
    const viewAll = search.querySelector('[data-header-search-view-all]');
    let returnFocus = toggle;
    let suppressLaunch = false;
    let searchTimer;
    let activeController;
    let activeIndex = -1;
    let resultId = 0;

    if (!toggle || !input || !results) return;

    const getResultLinks = () => Array.from(results.querySelectorAll('.header__search-result'));

    const setActiveSuggestion = (index) => {
      const links = getResultLinks();
      activeIndex = links.length && index >= 0 ? (index + links.length) % links.length : -1;

      links.forEach((link, linkIndex) => {
        const isActive = linkIndex === activeIndex;
        link.classList.toggle('is-active', isActive);
        link.setAttribute('aria-selected', String(isActive));
      });

      if (activeIndex >= 0 && links[activeIndex]?.id) {
        input.setAttribute('aria-activedescendant', links[activeIndex].id);
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    };

    const setState = (message) => {
      setActiveSuggestion(-1);
      results.replaceChildren();
      if (!message) return;
      const state = document.createElement('div');
      state.className = 'header__search-state';
      state.textContent = message;
      results.appendChild(state);
    };

    const closeSearch = () => {
      if (!search.classList.contains('is-open')) return;
      search.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      panel.inert = true;
      document.body.classList.remove('is-header-search-open');
      setActiveSuggestion(-1);
      suppressLaunch = true;
      if (returnFocus?.isConnected) returnFocus.focus();
      queueMicrotask(() => { suppressLaunch = false; });
    };

    const openSearch = () => {
      if (search.classList.contains('is-open')) return;
      returnFocus = document.activeElement === launcher ? launcher : toggle;
      if (mobileMenuDrawer?.classList.contains('open')) closeMobileMenu();
      panel.inert = false;
      document.body.classList.add('is-header-search-open');
      document.querySelectorAll('[data-header-search].is-open').forEach((item) => {
        if (item !== search) {
          item.classList.remove('is-open');
          item.querySelector('[data-header-search-toggle]')?.setAttribute('aria-expanded', 'false');
        }
      });
      document.querySelectorAll('[data-header-notification].is-open').forEach((item) => {
        item.classList.remove('is-open');
        item.querySelector('[data-header-notification-toggle]')?.setAttribute('aria-expanded', 'false');
      });
      search.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      window.setTimeout(() => input.focus(), 0);
    };

    const getImageUrl = (item) => {
      if (typeof item.image === 'string') return item.image;
      return item.image?.url || item.featured_image?.url || item.featured_image || '';
    };

    const appendResult = (item, type) => {
      const link = document.createElement('a');
      link.className = 'header__search-result';
      link.href = item.url || '#';
      link.id = `HeaderSearchResult-${Date.now()}-${resultId}`;
      link.tabIndex = -1;
      link.setAttribute('role', 'option');
      link.setAttribute('aria-selected', 'false');
      resultId += 1;

      const imageWrap = document.createElement('span');
      imageWrap.className = 'header__search-result-image';
      const imageUrl = getImageUrl(item);
      if (imageUrl) {
        const image = document.createElement('img');
        image.src = imageUrl;
        image.alt = item.title || '';
        image.loading = 'lazy';
        imageWrap.appendChild(image);
      }

      const copy = document.createElement('span');
      const title = document.createElement('span');
      title.className = 'header__search-result-title';
      title.textContent = item.title || 'Untitled';
      const resultType = document.createElement('span');
      resultType.className = 'header__search-result-type';
      resultType.textContent = type;
      copy.append(title, resultType);

      link.append(imageWrap, copy);
      results.appendChild(link);
    };

    const runSearch = async () => {
      const query = input.value.trim();
      activeController?.abort();
      discovery.hidden = query.length > 0;
      matches.hidden = query.length === 0;
      viewAll.hidden = true;
      viewAll.href = `${form.action}?q=${encodeURIComponent(query)}&type=product,article,page`;

      if (query.length < 2) {
        setState(query ? 'Keep typing' : '');
        return;
      }

      activeController = new AbortController();
      setState('Searching...');

      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,article,page&resources[limit]=6`;
        const response = await fetch(url, {
          headers: { Accept: 'application/json' },
          signal: activeController.signal,
        });
        if (!response.ok) throw new Error('Search request failed');
        const data = await response.json();
        if (input.value.trim() !== query || !search.classList.contains('is-open')) return;
        viewAll.hidden = false;
        const searchResults = data.resources?.results || {};
        const groups = [
          ['Product', searchResults.products || []],
          ['Article', searchResults.articles || []],
          ['Page', searchResults.pages || []],
        ];

        results.replaceChildren();
        setActiveSuggestion(-1);
        resultId = 0;
        groups.forEach(([type, items]) => items.forEach((item) => appendResult(item, type)));
        if (!results.children.length) setState('No results found');
      } catch (error) {
        if (error.name === 'AbortError') return;
        setState('Search is unavailable');
      }
    };

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (search.classList.contains('is-open')) {
        closeSearch();
      } else {
        openSearch();
      }
    });

    input.addEventListener('input', () => {
      launcher.value = input.value;
      discovery.hidden = input.value.trim().length > 0;
      matches.hidden = !discovery.hidden;
      setActiveSuggestion(-1);
      clearTimeout(searchTimer);
      searchTimer = window.setTimeout(runSearch, 180);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeSearch();
        return;
      }

      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        const links = getResultLinks();
        if (!links.length) return;
        event.preventDefault();
        setActiveSuggestion(event.key === 'ArrowDown' ? activeIndex + 1 : activeIndex - 1);
        return;
      }

      if (event.key === 'Enter' && activeIndex >= 0) {
        const activeLink = getResultLinks()[activeIndex];
        if (activeLink) {
          event.preventDefault();
          window.location.href = activeLink.href;
        }
      }
    });

    form?.addEventListener('submit', (event) => {
      if (!input.value.trim()) {
        event.preventDefault();
        setState('');
      }
    });

    results.addEventListener('pointerdown', (event) => {
      if (event.target.closest('.header__search-result')) {
        event.preventDefault();
      }
    });

    launcher.addEventListener('focus', () => {
      if (suppressLaunch) return;
      input.value = launcher.value;
      openSearch();
      runSearch();
    });
    launchForm.addEventListener('submit', (event) => {
      event.preventDefault();
      input.value = launcher.value;
      openSearch();
      runSearch();
    });
    search.querySelector('[data-header-search-close]').addEventListener('click', closeSearch);
    search.querySelector('[data-header-search-backdrop]').addEventListener('click', closeSearch);
    search.querySelectorAll('[data-header-search-term]').forEach((button) => {
      button.addEventListener('click', () => {
        clearTimeout(searchTimer);
        input.value = button.dataset.headerSearchTerm;
        launcher.value = input.value;
        setActiveSuggestion(-1);
        runSearch();
        input.focus();
      });
    });
    search.addEventListener('click', (event) => event.stopPropagation());
    document.addEventListener('click', closeSearch);
    document.addEventListener('keydown', (event) => {
      if (!search.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeSearch();
      }
      if (event.key === 'Tab') {
        const focusable = Array.from(panel.querySelectorAll('button, input, a[href], [tabindex]')).filter((el) => !el.disabled && el.tabIndex >= 0 && el.getClientRects().length && !el.closest('[hidden]'));
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    });
  });

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartDrawerItems = cartDrawer?.querySelector('[data-cart-drawer-items]');
  const cartDrawerSubtotalPrices = cartDrawer?.querySelector('.cart-drawer__subtotal-prices');
  const cartDrawerSubtotal = cartDrawer?.querySelector('[data-cart-drawer-subtotal]');
  const cartCountBadges = document.querySelectorAll('.header__cart-count');
  const cartNoteInput = cartDrawer?.querySelector('[data-cart-note]');
  const variantComparePriceCache = new Map();
  let cartNoteTimer;

  const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  }[char]));

  const formatMoney = (cents) => {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    const currency = window.Shopify?.currency?.active || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency,
    }).format((Number(cents) || 0) / 100);
  };

  const getCartItemCompareUnitPrice = async (item) => {
    const currentUnitPrice = Number(item.final_price || item.price || 0);
    const handle = item.handle || (item.url || '').match(/\/products\/([^/?#]+)/)?.[1];
    if (!handle || !item.variant_id) return currentUnitPrice;

    const cacheKey = `${handle}:${item.variant_id}`;
    if (variantComparePriceCache.has(cacheKey)) return variantComparePriceCache.get(cacheKey);

    try {
      const response = await fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to load product pricing');
      const product = await response.json();
      const variant = product.variants?.find((entry) => Number(entry.id) === Number(item.variant_id));
      const compareAtPrice = Number(variant?.compare_at_price || 0);
      const variantPrice = Number(variant?.price || currentUnitPrice);
      const compareUnitPrice = compareAtPrice > variantPrice ? compareAtPrice : currentUnitPrice;
      variantComparePriceCache.set(cacheKey, compareUnitPrice);
      return compareUnitPrice;
    } catch (error) {
      variantComparePriceCache.set(cacheKey, currentUnitPrice);
      return currentUnitPrice;
    }
  };

  const getCartCompareTotal = async (cart) => {
    const lineTotals = await Promise.all(cart.items.map(async (item) => {
      const compareUnitPrice = await getCartItemCompareUnitPrice(item);
      return compareUnitPrice * (Number(item.quantity) || 0);
    }));
    return lineTotals.reduce((total, lineTotal) => total + lineTotal, 0);
  };

  const renderCartDrawerSummary = (currentCartTotal, compareCartTotal) => {
    if (!cartDrawerSubtotalPrices) {
      if (cartDrawerSubtotal) {
        cartDrawerSubtotal.textContent = formatMoney(currentCartTotal);
        cartDrawerSubtotal.dataset.cartSubtotalCents = String(currentCartTotal);
      }
      return;
    }

    if (compareCartTotal > currentCartTotal) {
      const savingAmount = compareCartTotal - currentCartTotal;
      const savingPercent = Math.max(1, Math.round((savingAmount / compareCartTotal) * 100));
      cartDrawerSubtotalPrices.innerHTML = `
        <span class="cart-drawer__save" data-cart-drawer-save>Save ${savingPercent}%</span>
        <span class="cart-drawer__original-total" data-cart-drawer-compare>${formatMoney(compareCartTotal)}</span>
        <strong data-cart-drawer-subtotal data-cart-subtotal-cents="${currentCartTotal}">${formatMoney(currentCartTotal)}</strong>
      `;
      return;
    }

    cartDrawerSubtotalPrices.innerHTML = `<strong data-cart-drawer-subtotal data-cart-subtotal-cents="${currentCartTotal}">${formatMoney(currentCartTotal)}</strong>`;
  };

  const openCartDrawer = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-cart-drawer-open');
  };

  const closeCartDrawer = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-cart-drawer-open');
  };

  const renderCartDrawer = async (cart) => {
    const cartItemCount = Number(cart.item_count) || 0;
    cartCountBadges.forEach((badge) => {
      badge.textContent = cartItemCount;
      badge.hidden = cartItemCount <= 0;
      badge.setAttribute('aria-hidden', String(cartItemCount <= 0));
    });
    document.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => {
      trigger.setAttribute('aria-label', `Cart, ${cartItemCount} items`);
    });
    const currentCartTotal = Number(cart.total_price) || 0;
    const compareCartTotal = await getCartCompareTotal(cart);
    renderCartDrawerSummary(currentCartTotal, compareCartTotal);
    if (!cartDrawerItems) return;

    if (!cart.items.length) {
      cartDrawerItems.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      return;
    }

    cartDrawerItems.innerHTML = cart.items.map((item) => {
      const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<span class="cart-drawer__variant">${escapeHtml(item.variant_title)}</span>` : '';
      return `
        <div class="cart-drawer__item" data-cart-line data-line-key="${escapeHtml(item.key)}">
          <a class="cart-drawer__image" href="${escapeHtml(item.url)}">${image}</a>
          <div class="cart-drawer__item-copy">
            <a class="cart-drawer__item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
            ${variant}
            <div class="cart-drawer__line-bottom">
              <div class="quantity-stepper cart-drawer__quantity" data-cart-quantity>
                <button type="button" data-cart-quantity-minus aria-label="Decrease quantity">-</button>
                <input class="field" type="number" min="0" value="${item.quantity}" data-cart-quantity-input>
                <button type="button" data-cart-quantity-plus aria-label="Increase quantity">+</button>
              </div>
              <span class="cart-drawer__line-price">${formatMoney(item.final_line_price)}</span>
            </div>
          </div>
        </div>
      `;
    }).join('');
  };

  const fetchCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    let cart = await response.json();
    if (window.HipgagaGifts) cart = (await window.HipgagaGifts.sync()).cart;
    await renderCartDrawer(cart);
    return cart;
  };

  const updateCartNote = async () => {
    if (!cartNoteInput) return;
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: cartNoteInput.value }),
    });
  };

  const addProductToCart = async (form, showDrawer = true) => {
    if (!form) return null;
    const submitButtons = form.querySelectorAll('button[type="submit"], [data-sticky-buy-now]');
    submitButtons.forEach((submit) => {
      submit.disabled = true;
    });

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error('Unable to add item');
      const cart = await fetchCart();
      if (showDrawer) openCartDrawer();
      return cart;
    } finally {
      submitButtons.forEach((submit) => {
        submit.disabled = false;
      });
    }
  };

  document.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => {
    trigger.addEventListener('click', async (event) => {
      event.preventDefault();
      openCartDrawer();
      try {
        await fetchCart();
      } catch (error) {
        // Keep the server-rendered cart visible if Ajax is unavailable.
      }
    });
  });

  cartDrawer?.querySelectorAll('[data-cart-drawer-close]').forEach((button) => {
    button.addEventListener('click', closeCartDrawer);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeCartDrawer();
  });

  cartDrawerItems?.addEventListener('click', async (event) => {
    const line = event.target.closest('[data-cart-line]');
    if (!line) return;
    const input = line.querySelector('[data-cart-quantity-input]');
    if (!input) return;
    if (event.target.matches('[data-cart-quantity-minus]')) {
      input.value = Math.max(0, (Number(input.value) || 0) - 1);
    } else if (event.target.matches('[data-cart-quantity-plus]')) {
      input.value = (Number(input.value) || 0) + 1;
    } else {
      return;
    }
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  cartDrawerItems?.addEventListener('change', async (event) => {
    const input = event.target.closest('[data-cart-quantity-input]');
    const line = event.target.closest('[data-cart-line]');
    if (!input || !line) return;
    const quantity = Math.max(0, Number(input.value) || 0);
    input.disabled = true;
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.dataset.lineKey, quantity }),
      });
      if (!response.ok) throw new Error('Unable to update cart');
      const updated = await response.json();
      await renderCartDrawer(window.HipgagaGifts ? (await window.HipgagaGifts.sync()).cart : updated);
    } finally {
      input.disabled = false;
    }
  });

  cartNoteInput?.addEventListener('input', () => {
    clearTimeout(cartNoteTimer);
    cartNoteTimer = window.setTimeout(() => updateCartNote().catch(() => {}), 450);
  });

  cartDrawer?.querySelector('[data-cart-checkout]')?.addEventListener('click', async () => {
    await updateCartNote().catch(() => {});
    if (window.HipgagaGifts) await window.HipgagaGifts.sync().catch(() => {});
    window.location.href = '/checkout';
  });

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (form.dataset.skipAjaxCart === 'true') return;
      event.preventDefault();
      await addProductToCart(form, true).catch(() => {
        form.dataset.skipAjaxCart = 'true';
        form.submit();
      });
    });
  });

  document.querySelectorAll('[data-tabs]').forEach((tabs) => {
    tabs.querySelectorAll('[role="tab"]').forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.querySelectorAll('[role="tab"]').forEach((item) => item.setAttribute('aria-selected', 'false'));
        tabs.querySelectorAll('[role="tabpanel"]').forEach((panel) => panel.classList.remove('is-active'));
        tab.setAttribute('aria-selected', 'true');
        tabs.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`)?.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('[data-slideshow]').forEach((slideshow) => {
    const slides = Array.from(slideshow.querySelectorAll('[data-slide]'));
    const dots = Array.from(slideshow.querySelectorAll('[data-slide-dot]'));
    const prev = slideshow.querySelector('[data-slide-prev]');
    const next = slideshow.querySelector('[data-slide-next]');
    const autoplay = slideshow.dataset.autoplay === 'true';
    const interval = Number(slideshow.dataset.interval) || 5000;
    let activeIndex = 0;
    let timer;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchDeltaX = 0;
    let touchDeltaY = 0;
    let isHorizontalSwipe = false;
    const desktopMedia = window.matchMedia('(min-width: 750px)');
    let pointerStartX = 0;
    let pointerStartY = 0;
    let pointerDeltaX = 0;
    let pointerDeltaY = 0;
    let activePointerId = null;
    let isPointerDragging = false;
    let suppressSlideshowClick = false;

    if (slides.length < 2) return;

    const showSlide = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeIndex));
    };

    const restart = () => {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(() => showSlide(activeIndex + 1), interval);
    };

    prev?.addEventListener('click', () => {
      showSlide(activeIndex - 1);
      restart();
    });
    next?.addEventListener('click', () => {
      showSlide(activeIndex + 1);
      restart();
    });
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        showSlide(Number(dot.dataset.slideDot));
        restart();
      });
    });

    slideshow.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      touchDeltaX = 0;
      touchDeltaY = 0;
      isHorizontalSwipe = false;
    });

    slideshow.addEventListener('touchmove', (event) => {
      if (event.touches.length !== 1) return;
      touchDeltaX = event.touches[0].clientX - touchStartX;
      touchDeltaY = event.touches[0].clientY - touchStartY;
      isHorizontalSwipe = Math.abs(touchDeltaX) > Math.abs(touchDeltaY);
      if (isHorizontalSwipe) event.preventDefault();
    }, { passive: false });

    slideshow.addEventListener('touchend', () => {
      if (isHorizontalSwipe && Math.abs(touchDeltaX) > 50) {
        showSlide(activeIndex + (touchDeltaX < 0 ? 1 : -1));
        restart();
      }
      touchStartX = 0;
      touchStartY = 0;
      touchDeltaX = 0;
      touchDeltaY = 0;
      isHorizontalSwipe = false;
    });

    const resetPointerDrag = () => {
      pointerStartX = 0;
      pointerStartY = 0;
      pointerDeltaX = 0;
      pointerDeltaY = 0;
      activePointerId = null;
      isPointerDragging = false;
      slideshow.classList.remove('is-dragging');
    };

    slideshow.addEventListener('pointerdown', (event) => {
      if (!desktopMedia.matches || event.button !== 0 || event.pointerType === 'touch') return;
      if (event.target.closest('a, button, input, select, textarea, label')) return;
      activePointerId = event.pointerId;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
      pointerDeltaX = 0;
      pointerDeltaY = 0;
      isPointerDragging = true;
      slideshow.classList.add('is-dragging');
      clearInterval(timer);
      slideshow.setPointerCapture?.(event.pointerId);
    });

    slideshow.addEventListener('pointermove', (event) => {
      if (!isPointerDragging || event.pointerId !== activePointerId) return;
      pointerDeltaX = event.clientX - pointerStartX;
      pointerDeltaY = event.clientY - pointerStartY;
      if (Math.abs(pointerDeltaX) > 8 && Math.abs(pointerDeltaX) > Math.abs(pointerDeltaY)) {
        event.preventDefault();
      }
    });

    slideshow.addEventListener('pointerup', (event) => {
      if (!isPointerDragging || event.pointerId !== activePointerId) return;
      const isDesktopSwipe = Math.abs(pointerDeltaX) > Math.abs(pointerDeltaY);
      if (isDesktopSwipe && Math.abs(pointerDeltaX) > 60) {
        suppressSlideshowClick = true;
        showSlide(activeIndex + (pointerDeltaX < 0 ? 1 : -1));
        window.setTimeout(() => {
          suppressSlideshowClick = false;
        }, 250);
      }
      restart();
      resetPointerDrag();
    });

    slideshow.addEventListener('pointercancel', () => {
      restart();
      resetPointerDrag();
    });

    slideshow.addEventListener('click', (event) => {
      if (!suppressSlideshowClick) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    restart();
  });

  document.querySelectorAll('[data-collection-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('.collection-carousel__viewport');
    const menuButtons = Array.from(carousel.querySelectorAll('[data-collection-menu]'));
    const cards = Array.from(carousel.querySelectorAll('[data-collection-card]'));
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    if (!viewport) return;
    let autoTimer;

    const getVisibleCards = () => cards.filter((card) => !card.hidden);

    const canScroll = () => viewport.scrollWidth > viewport.clientWidth + 2;

    const showMenu = (menu) => {
      menuButtons.forEach((button) => {
        const active = button.dataset.collectionMenu === menu;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      cards.forEach((card) => {
        card.hidden = card.dataset.collectionParent !== menu;
      });
      viewport.scrollTo({ left: 0, behavior: 'smooth' });
      restartAuto();
    };

    menuButtons.forEach((button) => {
      button.addEventListener('mouseenter', () => showMenu(button.dataset.collectionMenu));
      button.addEventListener('click', () => showMenu(button.dataset.collectionMenu));
    });

    const scrollByCard = (direction) => {
      const card = viewport.querySelector('.collection-card:not([hidden])');
      const amount = card ? card.getBoundingClientRect().width + 18 : viewport.clientWidth;
      const nextLeft = viewport.scrollLeft + direction * amount;
      const maxLeft = viewport.scrollWidth - viewport.clientWidth;

      if (direction > 0 && nextLeft >= maxLeft - 2) {
        viewport.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }

      if (direction < 0 && nextLeft <= 0) {
        viewport.scrollTo({ left: maxLeft, behavior: 'smooth' });
        return;
      }

      viewport.scrollTo({ left: nextLeft, behavior: 'smooth' });
    };

    const startAuto = () => {
      clearInterval(autoTimer);
      if (getVisibleCards().length <= 1 || !canScroll()) return;
      autoTimer = setInterval(() => scrollByCard(1), 3800);
    };

    const restartAuto = () => {
      startAuto();
    };

    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:block:select', (event) => {
        const selectedCard = event.target?.closest?.('[data-collection-card]');
        if (!selectedCard || !carousel.contains(selectedCard)) return;
        showMenu(selectedCard.dataset.collectionParent);
      });
    }

    prev?.addEventListener('click', () => {
      scrollByCard(-1);
      restartAuto();
    });
    next?.addEventListener('click', () => {
      scrollByCard(1);
      restartAuto();
    });
    carousel.addEventListener('mouseenter', () => clearInterval(autoTimer));
    carousel.addEventListener('mouseleave', startAuto);
    window.addEventListener('resize', restartAuto);
    startAuto();
  });

  const initFeaturedCollectionCarousels = (root = document) => {
    root.querySelectorAll('[data-featured-collection-carousel]').forEach((carousel) => {
      if (carousel.dataset.featuredCarouselReady === 'true') return;
      carousel.dataset.featuredCarouselReady = 'true';

      const viewport = carousel.querySelector('.featured-collection__viewport');
      const track = carousel.querySelector('.featured-collection__track');
      const section = carousel.closest('.featured-collection-section');
      const prev = section?.querySelector('[data-featured-carousel-prev]');
      const next = section?.querySelector('[data-featured-carousel-next]');
      if (!viewport || !track) return;

      const canScroll = () => viewport.scrollWidth > viewport.clientWidth + 2;

      const updateControls = () => {
        const enabled = canScroll();
        [prev, next].forEach((button) => {
          if (button) button.hidden = !enabled;
        });
      };

      const getStep = () => {
        const card = viewport.querySelector('[data-featured-product-card]');
        const style = window.getComputedStyle(track);
        const gap = parseFloat(style.columnGap || style.gap) || 0;
        return card ? card.getBoundingClientRect().width + gap : viewport.clientWidth;
      };

      const scrollByCard = (direction) => {
        const maxLeft = viewport.scrollWidth - viewport.clientWidth;
        const nextLeft = viewport.scrollLeft + direction * getStep();

        if (direction > 0 && nextLeft >= maxLeft - 2) {
          viewport.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }

        if (direction < 0 && nextLeft <= 0) {
          viewport.scrollTo({ left: maxLeft, behavior: 'smooth' });
          return;
        }

        viewport.scrollTo({ left: nextLeft, behavior: 'smooth' });
      };

      prev?.addEventListener('click', () => scrollByCard(-1));
      next?.addEventListener('click', () => scrollByCard(1));
      window.addEventListener('resize', updateControls);
      updateControls();
    });
  };

  initFeaturedCollectionCarousels();
  document.addEventListener('shopify:section:load', (event) => initFeaturedCollectionCarousels(event.target));

  document.querySelectorAll('[data-random-product-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('.you-may-like__viewport');
    const track = carousel.querySelector('.you-may-like__track');
    const cards = Array.from(carousel.querySelectorAll('[data-random-product-card]'));
    const prev = carousel.querySelector('[data-random-carousel-prev]');
    const next = carousel.querySelector('[data-random-carousel-next]');
    if (!viewport || !track || !cards.length) return;

    cards
      .map((card) => ({ card, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .forEach(({ card }) => track.appendChild(card));

    const scrollByCard = (direction) => {
      const card = viewport.querySelector('[data-random-product-card]');
      const amount = card ? card.getBoundingClientRect().width + 18 : viewport.clientWidth;
      viewport.scrollBy({ left: direction * amount, behavior: 'smooth' });
    };

    prev?.addEventListener('click', () => scrollByCard(-1));
    next?.addEventListener('click', () => scrollByCard(1));
  });

  document.querySelectorAll('[data-blog-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('.blog-carousel__viewport');
    const prev = carousel.querySelector('[data-blog-carousel-prev]');
    const next = carousel.querySelector('[data-blog-carousel-next]');
    if (!viewport) return;

    const scrollByCard = (direction) => {
      const card = viewport.querySelector('.blog-carousel__item');
      const amount = card ? card.getBoundingClientRect().width + 18 : viewport.clientWidth;
      viewport.scrollBy({ left: direction * amount, behavior: 'smooth' });
    };

    prev?.addEventListener('click', () => scrollByCard(-1));
    next?.addEventListener('click', () => scrollByCard(1));
  });

  const getVideoEmbedSrc = (src, options = {}) => {
    try {
      const url = new URL(src, window.location.origin);
      const host = url.hostname.replace(/^www\./, '');
      const withAutoplay = (embedUrl) => {
        if (options.autoplay) embedUrl.searchParams.set('autoplay', '1');
        if (options.muted) {
          embedUrl.searchParams.set('muted', '1');
          embedUrl.searchParams.set('mute', '1');
        }
        if (options.loop) embedUrl.searchParams.set('loop', '1');
        embedUrl.searchParams.set('playsinline', '1');
        return embedUrl.toString();
      };

      const withVimeoPlayerOptions = (embedUrl) => {
        if (options.cleanUi) {
          embedUrl.searchParams.set('title', '0');
          embedUrl.searchParams.set('byline', '0');
          embedUrl.searchParams.set('portrait', '0');
          embedUrl.searchParams.set('badge', '0');
          embedUrl.searchParams.set('controls', '0');
          embedUrl.searchParams.set('pip', '0');
        }
        embedUrl.searchParams.set('dnt', '1');
        embedUrl.searchParams.set('autopause', '0');
        embedUrl.searchParams.set('transparent', '0');
        return withAutoplay(embedUrl);
      };

      if (host === 'youtu.be') {
        const id = url.pathname.split('/').filter(Boolean)[0];
        if (!id) return src;
        const embedUrl = new URL(`https://www.youtube.com/embed/${id}`);
        if (options.loop) embedUrl.searchParams.set('playlist', id);
        return withAutoplay(embedUrl);
      }

      if (host === 'youtube.com' || host === 'm.youtube.com') {
        const watchId = url.searchParams.get('v');
        const pathParts = url.pathname.split('/').filter(Boolean);
        const videoId = watchId || (pathParts[0] === 'shorts' ? pathParts[1] : null);
        if (!videoId) return src;
        const embedUrl = new URL(`https://www.youtube.com/embed/${videoId}`);
        if (options.loop) embedUrl.searchParams.set('playlist', videoId);
        return withAutoplay(embedUrl);
      }

      if (host === 'player.vimeo.com') {
        return withVimeoPlayerOptions(url);
      }

      if (host === 'vimeo.com' || host === 'm.vimeo.com') {
        const pathParts = url.pathname.split('/').filter(Boolean);
        const id = pathParts.find((part) => /^\d+$/.test(part));
        if (!id) return src;

        const embedUrl = new URL(`https://player.vimeo.com/video/${id}`);
        const hash = url.searchParams.get('h') || pathParts[pathParts.indexOf(id) + 1];
        if (hash && /^[a-zA-Z0-9]+$/.test(hash)) {
          embedUrl.searchParams.set('h', hash);
        }
        return withVimeoPlayerOptions(embedUrl);
      }
    } catch (error) {
      return src;
    }

    return src;
  };

  const getEmbedCodeSrc = (embedCode) => {
    if (!embedCode) return '';
    const decoded = document.createElement('textarea');
    decoded.innerHTML = embedCode;
    const html = decoded.value;
    const match = html.match(/<iframe[^>]+src=["']([^"']+)["']/i);
    return match ? match[1] : html.trim();
  };

  const isDirectVideoSrc = (src) => /\.(mp4|webm|ogg)(\?.*)?$/i.test(src);

  const initExternalVideos = (root = document) => {
    root.querySelectorAll('[data-external-video]').forEach((video) => {
      const poster = video.querySelector('[data-video-src]');
      const embedCode = video.querySelector('[data-video-embed]')?.textContent;
      if (!poster || poster.dataset.videoReady === 'true') return;
      poster.dataset.videoReady = 'true';

      const options = {
        autoplay: video.dataset.videoAutoplay === 'true',
        muted: video.dataset.videoMuted !== 'false',
        loop: video.dataset.videoLoop === 'true',
        cleanUi: video.dataset.videoCleanUi !== 'false',
      };

      const playVideo = () => {
        if (video.dataset.videoLoaded === 'true') return;
        video.dataset.videoLoaded = 'true';
        const rawSrc = getEmbedCodeSrc(embedCode) || poster.dataset.videoSrc;
        const src = getVideoEmbedSrc(rawSrc, { ...options, autoplay: true });
        if (!src) return;

        if (isDirectVideoSrc(src)) {
          const posterImage = poster.querySelector('img');
          const media = document.createElement('video');
          media.controls = true;
          media.autoplay = options.autoplay;
          media.muted = options.muted;
          media.loop = options.loop;
          media.playsInline = true;
          media.preload = 'none';
          if (posterImage?.currentSrc || posterImage?.src) media.poster = posterImage.currentSrc || posterImage.src;
          media.src = src;
          media.className = 'external-video__iframe external-video__media';
          video.replaceChildren(media);
          media.play?.().catch(() => {});
          return;
        }

        const iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.title = poster.getAttribute('aria-label') || 'External video';
        iframe.loading = 'lazy';
        iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.className = 'external-video__iframe';
        video.replaceChildren(iframe);
      };

      poster.addEventListener('click', playVideo);

      if (!options.autoplay) return;
      const startWhenVisible = () => {
        if ('IntersectionObserver' in window) {
          let posterTimer;
          const observer = new IntersectionObserver((entries) => {
            const visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.35);
            if (!visible) {
              clearTimeout(posterTimer);
              return;
            }
            clearTimeout(posterTimer);
            posterTimer = window.setTimeout(() => {
              observer.disconnect();
              playVideo();
            }, 1200);
          }, { threshold: [0, 0.35] });
          observer.observe(video);
          return;
        }
        window.setTimeout(playVideo, 1800);
      };

      if (document.readyState === 'complete') {
        startWhenVisible();
      } else {
        window.addEventListener('load', startWhenVisible, { once: true });
      }
    });
  };

  initExternalVideos();
  document.addEventListener('shopify:section:load', (event) => initExternalVideos(event.target));

  const initCustomerReviews = (root = document) => {
    root.querySelectorAll('[data-customer-reviews]').forEach((carousel) => {
      const viewport = carousel.querySelector('.customer-reviews__viewport');
      const cards = Array.from(carousel.querySelectorAll('.customer-review'));
      const prev = carousel.querySelector('[data-reviews-prev]');
      const next = carousel.querySelector('[data-reviews-next]');
      if (!viewport || carousel.dataset.reviewsReady === 'true') return;
      carousel.dataset.reviewsReady = 'true';
      let timer;

      const scrollByCard = (direction) => {
        const card = viewport.querySelector('.customer-review');
        const amount = card ? card.getBoundingClientRect().width + 18 : viewport.clientWidth;
        const maxLeft = viewport.scrollWidth - viewport.clientWidth;
        const nextLeft = viewport.scrollLeft + direction * amount;

        if (direction > 0 && nextLeft >= maxLeft - 2) {
          viewport.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }
        if (direction < 0 && nextLeft <= 0) {
          viewport.scrollTo({ left: maxLeft, behavior: 'smooth' });
          return;
        }
        viewport.scrollTo({ left: nextLeft, behavior: 'smooth' });
      };

      const start = () => {
        clearInterval(timer);
        if (cards.length <= 1 || viewport.scrollWidth <= viewport.clientWidth + 2) return;
        timer = setInterval(() => scrollByCard(1), 4300);
      };

      prev?.addEventListener('click', () => {
        scrollByCard(-1);
        start();
      });
      next?.addEventListener('click', () => {
        scrollByCard(1);
        start();
      });
      carousel.querySelectorAll('[data-review-expand-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const card = button.closest('.customer-review');
          const isExpanded = card?.classList.toggle('is-expanded') || false;
          button.setAttribute('aria-expanded', String(isExpanded));
          button.textContent = isExpanded ? button.dataset.expandedLabel : button.dataset.collapsedLabel;
          start();
        });
      });
      carousel.addEventListener('mouseenter', () => clearInterval(timer));
      carousel.addEventListener('mouseleave', start);
      window.addEventListener('resize', start);
      start();
    });
  };

  initCustomerReviews();
  document.addEventListener('shopify:section:load', (event) => initCustomerReviews(event.target));

  const initFaqHubs = (root = document) => {
    root.querySelectorAll('[data-faq-hub]').forEach((hub) => {
      if (hub.dataset.faqHubReady === 'true') return;
      hub.dataset.faqHubReady = 'true';
      const tabs = Array.from(hub.querySelectorAll('[data-faq-tab]'));
      const panels = Array.from(hub.querySelectorAll('[data-faq-panel]'));

      const getActivePanel = () => panels.find((panel) => panel.classList.contains('is-active'));
      const scrollActivePanel = (direction) => {
        const panel = getActivePanel();
        const viewport = panel?.querySelector('.faq-hub__viewport');
        const card = panel?.querySelector('.faq-hub__card');
        if (!viewport) return;
        const amount = card ? card.getBoundingClientRect().width + 18 : viewport.clientWidth;
        viewport.scrollBy({ left: direction * amount, behavior: 'smooth' });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          tabs.forEach((item) => {
            const active = item === tab;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', String(active));
          });
          panels.forEach((panel) => {
            const active = panel.dataset.faqPanel === tab.dataset.faqTab;
            panel.classList.toggle('is-active', active);
            if (active) panel.querySelector('.faq-hub__viewport')?.scrollTo({ left: 0 });
          });
        });
      });

      hub.querySelectorAll('[data-faq-prev]').forEach((button) => button.addEventListener('click', () => scrollActivePanel(-1)));
      hub.querySelectorAll('[data-faq-next]').forEach((button) => button.addEventListener('click', () => scrollActivePanel(1)));
    });
  };

  initFaqHubs();
  document.addEventListener('shopify:section:load', (event) => initFaqHubs(event.target));

  const initCountdownTimers = (root = document) => {
    const normalizeOffset = (offset) => {
      const match = String(offset || '').match(/^([+-])(\d{2})(\d{2})$/);
      return match ? `${match[1]}${match[2]}:${match[3]}` : '+00:00';
    };

    const parseStoreTime = (value, storeOffset) => {
      const raw = String(value || '').trim();
      if (!raw) return null;
      if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(raw)) {
        const explicitDate = new Date(raw.replace(' ', 'T'));
        return Number.isNaN(explicitDate.getTime()) ? null : explicitDate;
      }

      const match = raw.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:[ T](\d{1,2})(?::(\d{1,2}))?(?::(\d{1,2}))?)?$/);
      if (!match) return null;
      const [, year, month, day, hour = '0', minute = '0', second = '0'] = match;
      const normalized = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${hour.padStart(2, '0')}:${minute.padStart(2, '0')}:${second.padStart(2, '0')}${normalizeOffset(storeOffset)}`;
      const date = new Date(normalized);
      return Number.isNaN(date.getTime()) ? null : date;
    };

    const updateValue = (element, value) => {
      if (!element || element.textContent === value) return;
      element.textContent = value;
      element.classList.remove('is-flipping');
      void element.offsetWidth;
      element.classList.add('is-flipping');
    };

    root.querySelectorAll('[data-countdown-timer]').forEach((timer) => {
      if (timer.dataset.countdownReady === 'true') return;
      timer.dataset.countdownReady = 'true';
      const endTime = parseStoreTime(timer.dataset.countdownEnd, timer.dataset.storeOffset);
      const values = {
        days: timer.querySelector('[data-countdown-value="days"]'),
        hours: timer.querySelector('[data-countdown-value="hours"]'),
        minutes: timer.querySelector('[data-countdown-value="minutes"]'),
        seconds: timer.querySelector('[data-countdown-value="seconds"]'),
      };

      const renderExpired = () => {
        if (timer.dataset.expiredText) {
          const text = timer.querySelector('.product-countdown__text');
          if (text) text.textContent = timer.dataset.expiredText;
        }
        Object.values(values).forEach((element) => updateValue(element, '00'));
      };

      const render = () => {
        if (!endTime) {
          renderExpired();
          return;
        }
        const remaining = Math.max(0, endTime.getTime() - Date.now());
        if (remaining <= 0) {
          renderExpired();
          window.clearInterval(interval);
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        updateValue(values.days, String(days).padStart(2, '0'));
        updateValue(values.hours, String(hours).padStart(2, '0'));
        updateValue(values.minutes, String(minutes).padStart(2, '0'));
        updateValue(values.seconds, String(seconds).padStart(2, '0'));
      };

      const interval = window.setInterval(render, 1000);
      render();
    });
  };

  initCountdownTimers();
  document.addEventListener('shopify:section:load', (event) => initCountdownTimers(event.target));

  const backToTop = document.querySelector('[data-back-to-top]');
  if (backToTop) {
    const toggleBackToTop = () => {
      const recommendation = document.querySelector('.you-may-like');
      const mobile = window.matchMedia('(max-width:749px)').matches;
      const visible = mobile && recommendation
        ? recommendation.getBoundingClientRect().top <= window.innerHeight * 0.85
        : window.scrollY > 620;
      backToTop.classList.toggle('is-visible', visible);
    };
    backToTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    window.addEventListener('scroll', toggleBackToTop, { passive: true });
    window.addEventListener('resize', toggleBackToTop);
    window.addEventListener('load', toggleBackToTop);
    toggleBackToTop();
  }

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const mediaRoot = root.querySelector('[data-product-media-root]');
    let showVariantImage = () => {};
    if (mediaRoot) {
      const main = mediaRoot.querySelector('.product-gallery__main');
      const galleryImages = Array.from(mediaRoot.querySelectorAll('[data-product-gallery-image]'));
      const galleryThumbs = Array.from(mediaRoot.querySelectorAll('[data-product-gallery-thumb]'));
      const galleryPrev = mediaRoot.querySelector('[data-product-gallery-prev]');
      const galleryNext = mediaRoot.querySelector('[data-product-gallery-next]');
      const lightbox = root.querySelector('[data-product-lightbox]');
      const lightboxStage = root.querySelector('.product-lightbox__stage');
      const lightboxImages = Array.from(root.querySelectorAll('[data-lightbox-image]'));
      const lightboxThumbs = Array.from(root.querySelectorAll('[data-lightbox-thumb]'));
      let activeImage = Math.max(0, galleryImages.findIndex((image) => image.classList.contains('is-active')));
      let pxAllowedImages = galleryImages.map((_, index) => index);
      let pxGalleryConfig = { variants: [], options: [] };
      try { pxGalleryConfig = JSON.parse(root.querySelector('[data-px-variant-galleries]')?.textContent || '{}'); } catch (_) {}
      const pxMediaKey = (value) => { try { return decodeURIComponent(new URL(value, location.origin).pathname.split('/').pop()); } catch (_) { return value; } };

      let suppressMainClick = false;

      const resetLightboxZoom = () => {
        lightboxStage?.classList.remove('is-zoomed');
        lightboxImages.forEach((image) => image.classList.remove('is-zoomed'));
      };

      const showProductImage = (index) => {
        if (!galleryImages.length) return;
        const unavailable = mediaRoot.querySelector('[data-variant-image-unavailable]');
        if (unavailable) unavailable.hidden = true;
        resetLightboxZoom();
        let pxNext = (index + galleryImages.length) % galleryImages.length;
        if (!pxAllowedImages.includes(pxNext)) {
          const pxStep = index < activeImage ? -1 : 1;
          for (let pxTry = 0; pxTry < galleryImages.length; pxTry++) {
            pxNext = (pxNext + pxStep + galleryImages.length) % galleryImages.length;
            if (pxAllowedImages.includes(pxNext)) break;
          }
        }
        activeImage = pxAllowedImages.includes(pxNext) ? pxNext : pxAllowedImages[0];
        galleryImages.forEach((image, imageIndex) => image.classList.toggle('is-active', imageIndex === activeImage));
        galleryThumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === activeImage));
        lightboxImages.forEach((image, imageIndex) => image.classList.toggle('is-active', imageIndex === activeImage));
        lightboxThumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === activeImage));
      };

      showVariantImage = (imageId, variantId) => {
        const targetId = imageId || mediaRoot.dataset.variantFallbackImageId;
        const pxVariant = (pxGalleryConfig.variants || []).find(v => String(v.id) === String(variantId));
        const pxColorIndex = (pxGalleryConfig.options || []).findIndex(name => /color|colour|skin|tone|颜色|顏色|肤色|膚色/i.test(name));
        const pxHasColor = pxColorIndex >= 0 && (pxGalleryConfig.variants || []).length > 1;
        const pxKeys = new Set((pxVariant?.urls || []).map(pxMediaKey));
        pxAllowedImages = galleryImages.map((image, index) => ({ image, index })).filter(({ image }) => !pxHasColor || pxKeys.has(pxMediaKey(image.getAttribute('src'))) || String(image.dataset.productImageId) === String(targetId)).map(({ index }) => index);
        if (!pxAllowedImages.length) pxAllowedImages = galleryImages.map((image, index) => String(image.dataset.productImageId) === String(targetId) ? index : -1).filter(index => index >= 0);
        [galleryImages, galleryThumbs, lightboxImages, lightboxThumbs].forEach(items => items.forEach((item, index) => {
          const pxHidden = !pxAllowedImages.includes(index);
          item.dataset.pxColorHidden = String(pxHidden);
          if (pxHidden) item.classList.remove('is-active');
        }));
        const index = galleryImages.findIndex((image) => image.dataset.productImageId === targetId);
        const unavailable = mediaRoot.querySelector('[data-variant-image-unavailable]');
        if (unavailable) unavailable.hidden = index >= 0;
        if (index >= 0) {
          showProductImage(index);
        } else {
          resetLightboxZoom();
          [...galleryImages, ...galleryThumbs, ...lightboxImages, ...lightboxThumbs].forEach((item) => item.classList.remove('is-active'));
        }
      };

      const attachSwipeNavigation = (element) => {
        if (!element || galleryImages.length < 2) return;
        let startX = 0;
        let startY = 0;

        element.addEventListener('touchstart', (event) => {
          if (event.touches.length !== 1) return;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        }, { passive: true });

        element.addEventListener('touchend', (event) => {
          if (!startX) return;
          const touch = event.changedTouches[0];
          const diffX = touch.clientX - startX;
          const diffY = touch.clientY - startY;
          startX = 0;
          startY = 0;
          if (Math.abs(diffX) < 45 || Math.abs(diffX) < Math.abs(diffY) * 1.2) return;
          if (element === main) {
            suppressMainClick = true;
            window.setTimeout(() => { suppressMainClick = false; }, 250);
          }
          showProductImage(activeImage + (diffX < 0 ? 1 : -1));
        }, { passive: true });
      };

      const openLightbox = () => {
        if (!lightbox) return;
        lightbox.hidden = false;
        document.body.classList.add('is-locked');
        lightbox.querySelector('[data-lightbox-close]')?.focus();
      };

      const closeLightbox = () => {
        if (!lightbox) return;
        resetLightboxZoom();
        lightbox.hidden = true;
        document.body.classList.remove('is-locked');
      };

      main?.addEventListener('mouseenter', () => {
        main.classList.add('is-zooming');
      });

      main?.addEventListener('mousemove', (event) => {
        const rect = main.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
        main.style.setProperty('--zoom-x', `${x}%`);
        main.style.setProperty('--zoom-y', `${y}%`);
      });

      main?.addEventListener('mouseleave', () => {
        main.classList.remove('is-zooming');
      });

      attachSwipeNavigation(main);
      attachSwipeNavigation(lightboxStage);

      root.querySelectorAll('[data-lightbox-open]').forEach((button) => button.addEventListener('click', (event) => {
        if (suppressMainClick) {
          event.preventDefault();
          return;
        }
        openLightbox();
      }));
      galleryPrev?.addEventListener('click', (event) => {
        event.stopPropagation();
        showProductImage(activeImage - 1);
      });
      galleryNext?.addEventListener('click', (event) => {
        event.stopPropagation();
        showProductImage(activeImage + 1);
      });
      galleryThumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => showProductImage(Number(thumb.dataset.productGalleryThumb)));
      });
      root.querySelector('[data-lightbox-close]')?.addEventListener('click', closeLightbox);
      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) closeLightbox();
      });
      lightboxThumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => showProductImage(Number(thumb.dataset.lightboxThumb)));
      });
      lightboxImages.forEach((image) => {
        image.addEventListener('click', (event) => {
          event.stopPropagation();
          const isZoomed = image.classList.toggle('is-zoomed');
          lightboxStage?.classList.toggle('is-zoomed', isZoomed);
        });
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && lightbox && !lightbox.hidden) closeLightbox();
      });
    }

    const select = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const button = root.querySelector('[data-add-to-cart]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const stickyAtc = document.querySelector('[data-sticky-atc]');
    const stickyForm = document.getElementById('StickyProductForm');
    const stickyVariantSelect = stickyForm?.querySelector('[data-sticky-variant-select]');
    const stickyAddButton = stickyForm?.querySelector('[data-sticky-add-to-cart]');
    const stickyBuyButton = stickyForm?.querySelector('[data-sticky-buy-now]');
    const variantOptions = root.querySelectorAll('[data-variant-option]');
    const quantityStepper = root.querySelector('[data-quantity-stepper]');
    const quantityInput = root.querySelector('[data-quantity-input]');
    const buyNow = root.querySelector('[data-buy-now]');
    const productForm = root.querySelector('form[action*="/cart/add"]');

    quantityStepper?.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      const min = Number(quantityInput?.min) || 1;
      const value = Math.max(min, (Number(quantityInput?.value) || min) - 1);
      quantityInput.value = value;
    });

    quantityStepper?.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      const value = (Number(quantityInput?.value) || 1) + 1;
      quantityInput.value = value;
    });

    const stickyQuantityInput = stickyForm?.querySelector('[data-sticky-quantity-input]');
    stickyForm?.querySelector('[data-sticky-quantity-minus]')?.addEventListener('click', () => {
      const min = Number(stickyQuantityInput?.min) || 1;
      stickyQuantityInput.value = Math.max(min, (Number(stickyQuantityInput?.value) || min) - 1);
    });
    stickyForm?.querySelector('[data-sticky-quantity-plus]')?.addEventListener('click', () => {
      stickyQuantityInput.value = (Number(stickyQuantityInput?.value) || 1) + 1;
    });

    stickyVariantSelect?.addEventListener('change', () => {
      const selected = stickyVariantSelect.options[stickyVariantSelect.selectedIndex];
      const matchingOption = root.querySelector(`[data-variant-option][value="${CSS.escape(stickyVariantSelect.value)}"]`);
      if (matchingOption) {
        matchingOption.checked = true;
        updateVariantState(matchingOption);
      } else if (selected) {
        updateVariantState(selected);
      }
    });

    stickyBuyButton?.addEventListener('click', async () => {
      if (!variantOptions.length) {
        await addProductToCart(stickyForm, false).catch(() => {});
        window.location.href = '/checkout';
        return;
      }
      if (variantOptions.length && !validateVariantPurchase(stickyForm)) return;
      if (stickyBuyButton.disabled) return;
      try {
        await addProductToCart(stickyForm, false);
        window.location.href = '/checkout';
      } catch (error) {
        if (variantOptions.length) updateVariantState(root.querySelector('[data-variant-option]:checked'), false);
      }
    });

    buyNow?.addEventListener('click', async () => {
      if (!productForm || buyNow.disabled) return;
      if (variantOptions.length && !validateVariantPurchase(productForm)) return;
      const previousText = buyNow.textContent;
      buyNow.disabled = true;
      buyNow.textContent = 'Processing...';

      try {
        const formData = new FormData(productForm);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) throw new Error('Unable to add item');
        if (window.HipgagaGifts) await window.HipgagaGifts.sync();
        window.location.href = '/checkout';
      } catch (error) {
        buyNow.disabled = false;
        buyNow.textContent = previousText;
      }
    });

    const updateVariantState = (variantOption, updateUrl = true) => {
      if (!variantOption) return;
      const available = variantOption.dataset.available === 'true';
      if (variantOptions.length) {
        showVariantImage(variantOption.dataset.variantImageId, variantOption.value);
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantOption.value);
          window.history.replaceState({}, '', url);
        }
      }
      const priceDisplay = variantOption.dataset.priceDisplay || variantOption.dataset.price;
      const compare = variantOption.dataset.comparePriceDisplay || variantOption.dataset.comparePrice;
      const discount = Number(variantOption.dataset.discountPercent || 0);
      price.innerHTML = `<span class="price__sale">${priceDisplay}</span>${compare ? `<s class="price__compare">${compare}</s>` : ''}${discount > 0 ? `<span class="price__discount">-${discount}%</span>` : ''}`;
      if (stickyPrice) stickyPrice.innerHTML = priceDisplay;
      if (stickyVariantSelect && stickyVariantSelect.value !== variantOption.value) {
        stickyVariantSelect.value = variantOption.value;
      }
      button.disabled = !available;
      button.textContent = available ? button.dataset.availableLabel : button.dataset.soldLabel;
      if (stickyAddButton) {
        stickyAddButton.disabled = !available;
        stickyAddButton.textContent = available ? stickyAddButton.dataset.availableLabel : stickyAddButton.dataset.soldLabel;
      }
      if (stickyBuyButton) stickyBuyButton.disabled = !available;
      if (buyNow) buyNow.disabled = !available;
    };

    if (select) {
      select.addEventListener('change', () => updateVariantState(select.options[select.selectedIndex]));
    }

    variantOptions.forEach((variantOption) => {
      variantOption.addEventListener('change', () => updateVariantState(variantOption));
    });

    // Keep both purchase entry points on the same variant and quantity.
    // The existing picker lists complete Shopify variants, so impossible combinations cannot be selected.
    const validateVariantPurchase = (form) => {
      const selected = root.querySelector('[data-variant-option]:checked');
      const submittedId = new FormData(form).get('id');
      return Boolean(selected && !selected.disabled && selected.dataset.available === 'true' &&
        submittedId === selected.value && form.reportValidity());
    };
    if (variantOptions.length) {
      const syncQuantity = (source, target) => {
        if (source && target) target.value = source.value;
      };
      [quantityInput, stickyQuantityInput].forEach((input) => {
        input?.addEventListener('input', () => syncQuantity(input, input === quantityInput ? stickyQuantityInput : quantityInput));
        input?.addEventListener('change', () => syncQuantity(input, input === quantityInput ? stickyQuantityInput : quantityInput));
      });
      [quantityStepper, stickyForm?.querySelector('[data-sticky-quantity-stepper]')].forEach((stepper, index) => {
        stepper?.addEventListener('click', (event) => {
          if (event.target.closest('button')) syncQuantity(index ? stickyQuantityInput : quantityInput, index ? quantityInput : stickyQuantityInput);
        });
      });
      [productForm, stickyForm].forEach((form) => {
        form?.addEventListener('submit', (event) => {
          if (!validateVariantPurchase(form)) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, true);
      });
      updateVariantState(root.querySelector('[data-variant-option]:checked'), false);
    }

    if (stickyAtc && mediaRoot) {
      const updateStickyAtc = () => {
        const mediaTop = mediaRoot.getBoundingClientRect().top + window.scrollY;
        const isMobile = window.innerWidth < 750;
        const primaryButtonRect = button?.getBoundingClientRect();
        const primaryButtonVisible = primaryButtonRect
          ? primaryButtonRect.top < window.innerHeight - 88 && primaryButtonRect.bottom > 72
          : true;
        const overlayOpen = document.body.classList.contains('is-locked') ||
          document.body.classList.contains('is-cart-drawer-open') ||
          document.body.classList.contains('is-hipgaga-filter-open') ||
          document.body.classList.contains('is-mobile-menu-open') ||
          Boolean(document.querySelector('[data-header-search].is-open'));
        const shouldShow = isMobile
          ? !primaryButtonVisible && !overlayOpen
          : window.innerWidth >= 990 && window.scrollY > mediaTop + 80;
        stickyAtc.classList.toggle('is-visible', shouldShow);
        document.body.classList.toggle('has-mobile-sticky-atc', isMobile && shouldShow);
        stickyAtc.setAttribute('aria-hidden', String(!shouldShow || stickyAtc.classList.contains('is-faq-hidden')));
        suppressMobilePurchasePopups();
      };
      window.addEventListener('scroll', updateStickyAtc, { passive: true });
      window.addEventListener('resize', updateStickyAtc);
      document.addEventListener('click', () => window.setTimeout(updateStickyAtc, 0));
      updateStickyAtc();
    }
  });

  // Hide product sticky carts from the FAQ downward; only restore after scrolling back above FAQ.
  const stickyAtcBars = Array.from(document.querySelectorAll('[data-sticky-atc]'));
  const faqSections = Array.from(document.querySelectorAll('.faq-section, [data-faq-hub]'));
  if (stickyAtcBars.length && faqSections.length && 'IntersectionObserver' in window) {
    let stickyFaqHidden = false;
    let lastStickyFaqScrollY = window.scrollY;

    const getFirstFaqTop = () => Math.min(...faqSections.map((section) => (
      section.getBoundingClientRect().top + window.scrollY
    )));

    const setStickyAtcFaqHidden = (shouldHide) => {
      stickyFaqHidden = shouldHide;
      stickyAtcBars.forEach((stickyAtc) => {
        stickyAtc.classList.toggle('is-faq-hidden', shouldHide);
        stickyAtc.setAttribute('aria-hidden', String(shouldHide || !stickyAtc.classList.contains('is-visible')));
      });
    };

    const updateStickyAtcFaqFromScroll = () => {
      const currentScrollY = window.scrollY;
      const firstFaqTop = getFirstFaqTop();
      const isScrollingDown = currentScrollY > lastStickyFaqScrollY;
      if (isScrollingDown && currentScrollY + window.innerHeight * 0.45 >= firstFaqTop) {
        setStickyAtcFaqHidden(true);
      } else if (!isScrollingDown && stickyFaqHidden && currentScrollY + 120 < firstFaqTop) {
        setStickyAtcFaqHidden(false);
      }
      lastStickyFaqScrollY = currentScrollY;
    };

    const faqObserver = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        setStickyAtcFaqHidden(true);
      }
      updateStickyAtcFaqFromScroll();
    }, {
      rootMargin: '0px 0px -35% 0px',
      threshold: 0.01,
    });

    faqSections.forEach((section) => faqObserver.observe(section));
    window.addEventListener('scroll', updateStickyAtcFaqFromScroll, { passive: true });
    window.addEventListener('resize', updateStickyAtcFaqFromScroll);
    updateStickyAtcFaqFromScroll();
  }
});
